/**
 * Fallback local do modo corporativo.
 * Fonte de verdade em runtime: company.typeBusiness (2=corp, 1=escola).
 */
const parseFlag = (value, fallback = false) => {
    if (value === undefined || value === null || value === '') {
        return fallback;
    }
    return String(value).toLowerCase() === 'true' || value === '1';
};

export default {
    enabled: parseFlag(process.env.VUE_APP_CORPORATE_ENABLED, true),
    // Sempre API real para validar estrutura, liberação e acesso do colaborador.
    useMock: false,
    storageKey: 'weeduc_corporate_mock_v9',
};
